import { render, staticRenderFns } from "./banks.vue?vue&type=template&id=c2a6a078&"
import script from "./banks.vue?vue&type=script&lang=ts&"
export * from "./banks.vue?vue&type=script&lang=ts&"
import style0 from "./banks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports